import { type } from "jquery";
import Util from "../helpers/util";
import CartObject from "../helpers/cartUtil";
import {
  productListingPageNestHubMaxView,
  productListingPageNestHubView,
  productListingPageTabView,
  productListingPageMobileView,
} from "./pageVariables";

// Using shared singleton instance
var UtilObject = new Util();

import {
  getImageUrl,
  getVendorBusinessImageUrl,
  getAssetUrl,
} from "../helpers/mediaUrl";
import { buildProductCard } from "../helpers/cardComponents";

var vendorProducts;
var vendor;
var CartDetails = {};
var vendorFromOrder;
var flagForVendorCheck = false;
var pID;
var businessImageArray = [];
var screenWidth;

export default class productListing {
  constructor() {
    //calculating width and putting the appropriate code
    screenWidth = $(window).width();

    if (screenWidth < 576) {
      //$(".displayDuringDesktopView").addClass("d-none");
      $(".displayDuringMobView").removeClass("d-none");
    } else {
      //$(".displayDuringMobView").addClass("d-none");
      $(".displayDuringDesktopView").removeClass("d-none");
    }

    //ProductListingPage Part

    //desktop view class
    this.displayDuringDesktopView = $(".displayDuringDesktopView");

    //mobile view class
    this.displayDuringMobView = $(".displayDuringMobView");

    //add
    // this.addBtnForItem1 = $("#addBtnForItem1");

    //+
    // this.plusBtnId = $("#plusBtnId");

    //-
    // this.minusBtnId = $("#minusBtnId");

    //cartEmpty
    this.cartEmpty = $("#cartEmpty");

    //ItemsInCart
    this.ItemsAddedInCart = $("#ItemsAddedInCart");

    //text-field
    this.qntyTextField = $(".qntyTextField");

    //max error msg
    // this.maxErrorMsg = $("#maxErrorMsg");

    //Vendor_ID
    this.Vendor_ID = $(".ProductListingPage").attr("value");

    //div for description
    this.writtenPart = $(".writtenPart");

    //for integration
    this.grid = $(".ProductListingPage");
    this.productListingSkeleton = $(".product-listing-skeleton");

    $("a.continueShoppingBtn").on("click", this.maintainFlow);

    this.noOfProductsInCart = {
      Products: [],
      Products_Not_Available: [],
      vendor: null,
    };
    vendorFromOrder = null;

    var allCookies = UtilObject.getAllCookies() || {};

    //Get Cookies from Util Helper Class
    CartDetails = UtilObject.getAllCookies();

    //Registering Events
    if (this.Vendor_ID == "") {
      this.hideProductListingSkeleton();
      $(".emptyProductListingPage").removeClass("d-none");
    } else {
      $(".ProductListingPage").removeClass("d-none");
      this.bindEvents();
    }

    document.addEventListener("cart-updated", this.refreshCartCount);
  }
  hideProductListingSkeleton = () => {
    this.productListingSkeleton.addClass("d-none");
  };

  maintainFlow = () => {
    var allCookies = UtilObject.getAllCookies();

    //window.location = allCookies.PREVIOUS_PAGE;
    history.go(-1);
  };

  bindEvents = () => {
    //to adjust content according to different screen sizes
    var w = $(window).width();

    if (w < 710) {
      this.writtenPart.removeClass("col");
    } else {
      this.writtenPart.addClass("col");
    }

    // Proceed to Cart
    $(".proceedToCartBtn")
      .off("click")
      .on("click", () => {
        window.location.href = globalThis.baseURL + "customer/cart";
      });

    // this.addToCartBtn(this.addItemInCart)
    // this.addItemInCart();
    // this.addBtnForItem1.on("click", this.addItemInCart);
    // this.minusBtnId.on("click", this.minusItemFunction);
    // this.plusBtnId.on("click", this.plusItemFunction);

    // Trigger data fetching directly
    this.getVendorDetailsWithMultipleCategories();
    this.calOwlCarousel();
    //$(window).on("load", () => { this.getVendorDetails(); });
    //$(window).on("load", () => { this.getVendorImages(); });
    //calling commomon buttons
    // this.addToCartBtn.on("click", this.addItemInCart);

    $("button.btn.keepOldCart").on("click", () => {
      bootstrap.Modal.getOrCreateInstance("#showCartModal").hide();
    });

    $("button.btn.startNewCart").on("click", () => {
      bootstrap.Modal.getOrCreateInstance("#showCartModal").hide();
      this.deleteEntireCart();
      flagForVendorCheck = true;
      this.addItemtoCartAfterVendorCheck();
      // setTimeout(() => {
      //   window.location.reload();
      // }, 50);
    });

    $(".deleteCart").on("click", () => {
      window.$("#deleteCartModal").modal("show");
    });

    $("button.btn.emptyCart").on("click", () => {
      window.$("#deleteCartModal").modal("hide");
      this.deleteEntireCart();
      // setTimeout(() => {
      //   window.location.reload();
      // }, 50);
    });
  };

  calOwlCarousel = () => {
    $(".carousel_se_06_carousel").owlCarousel({
      nav: false,
      dots: false,
      mouseDrag: true,
      responsiveClass: true,
      responsive: {
        0: {
          items: 3,
        },
        480: {
          items: 3,
        },
        767: {
          items: 5,
        },
        992: {
          items: 6,
        },
        1200: {
          items: 8,
        },
      },
    });
  };

  //refreshes the count on header and footer
  refreshCartCount = async () => {
    this.noOfProductsInCart = await CartObject.cartCheck();
    vendorFromOrder = this.noOfProductsInCart.vendor;

    if (this.noOfProductsInCart && this.noOfProductsInCart.Products) {
      $("span.cartCount").html(`${this.noOfProductsInCart.Products.length}`);
    }

    var productsNotAvailable = this.noOfProductsInCart.Products_Not_Available;
    if (productsNotAvailable.length > 0) {
      productsNotAvailable.forEach((product) => {
        var mainProductDetail = product.Product_Details;
        if (mainProductDetail.Quantity == 0) {
          $(`.addToCartBtn[value="${product.Product_ID}"]`).replaceWith(
            `<button type="button" class="btn btn-sm btn-secondary text-white w-100" value="${product.Product_ID}">NOT AVAILABLE</button>`,
          );
        }
      });
    }

    //Refreshing Cart On UI
    if (this.noOfProductsInCart.Products.length > 0) {
      $(".vendorName").text(this.noOfProductsInCart.vendor.Business_Name);
      $(".cart-items").empty();
      var productsInCart = this.noOfProductsInCart.Products;
      productsInCart.forEach((product) => {
        var cartItem = `<div class="row d-flex align-items-center pb-1 ${product.Product_ID}" value="${product.Product_ID}">
      <div class="col-4 pt-1">
      ${product.ProductName}
      </div>
      <div class="col-4 p-0 d-flex justify-content-center itemPrice">
          <ul class="pagination m-0">
              <li class="page-item"><button class="page-link minusButton" value="${product.Product_ID}">-
                  </button>
              </li>

              <li class="page-item"><button min="0" max="${(product.Product_Details && product.Product_Details.Quantity) || product.Quantity || 0}" name="${product.Product_ID}" value="1" type="number" class="page-link quantityButton qntyTextField" disabled>${product.Quantity}</button>
              </li>

              <li class="page-item"> <button class="page-link plusButton" value="${product.Product_ID}">+

                  </button>
              </li>
          </ul>
      </div>
      <div class="col-4 pt-1 d-flex justify-content-center">
          ₹ ${product.Price}
      </div>
      <span class="text-danger maxErrorMsg" value="${product.Product_ID}"></span>
  </div>`;

        $(".cart-items").append(cartItem);

        //var button = `<button type="button" class="btn btn-sm text-white px-4 mt-2 w-100 ${product.Product_ID}" style="background: #ff385c; margin-left: 0rem;">ADDED</button>`;

        // //Vendor Availability Button check
        // if (checkIfVendorAvailable == false) {
        //   var button = `<button class="btn text-white px-5" id="${product.Product_ID}" style="background: rgba(192,192,192); margin-left:-5rem;" type="button">N/A</button>`;
        // } else {
        //   var button = `<button class="btn btn-xl text-white px-5 addToCartBtn ${product.Product_ID}" style="background: #ff385c;" type="button">Add</button>`;
        // }
        // //Vendor Availability Button check ends
        // var button = `<button type="button" class="btn btn-sm text-white w-100 addedToCart" style="background: #ff385c;" value="${product.Product_ID}">ADDED</button>`;
        // $(`.addToCartBtn[value="${product.Product_ID}"]`).replaceWith(button);
      });
      $(".plusButton").off("click");
      $(".plusButton").on("click", this.plusItemFunction);

      $(".minusButton").off("click");
      $(".minusButton").on("click", this.minusItemFunction);
    } else {
      if (this.noOfProductsInCart.vendor != null) {
        this.deleteEntireCart();
      }
    }
  };

  // getCookie = (name) => {
  //   let matches = document.cookie.match(
  //     new RegExp(
  //       "(?:^|; )" +
  //         name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, "\\$1") +
  //         "=([^;]*)"
  //     )
  //   );
  //   return matches ? decodeURIComponent(matches[1]) : undefined;
  // };

  // cartCheck = () => {
  //

  //   let orderIdFromPHP;

  //   var customerId = UtilObject.getCookie("CUSTOMER_ID");
  //   var orderId = UtilObject.getCookie("ORDER_ID");

  //   // var customerId = (document.cookie.match(
  //   //   /^(?:.;)?\s*customerID\s=\s*([^;]+)(?:.*)?$/
  //   // ) || [, null])[1];
  //   //

  //   // var orderid = (document.cookie.match(
  //   //   /^(?:.;)?\s*orderID\s=\s*([^;]+)(?:.*)?$/
  //   // ) || [, null])[1];

  //   if (orderId == null) {
  //     // $.ajax({
  //     //   url: globalThis.baseURL + "api/customer/Orders/setRandomSessionId",
  //     //   type: "POST",
  //     //   async: false,
  //     //   data: {
  //     //     name: "ORDER_ID",
  //     //   },
  //     //   success: (result) => {
  //     //
  //     //     UtilObject.createCookie("ORDER_ID", result.ORDER_ID, 1);
  //     //     orderIdFromPHP = result.ORDER_ID;
  //     //   },
  //     //   error: (err) => {
  //     //
  //     //   },
  //     // });

  //     $.ajax({
  //       url: globalThis.baseURL + "api/customer/Orders/setSessionId",
  //       type: "POST",
  //       async: false,
  //       data: {
  //         data: {
  //           ORDER_ID: "0063bb49-4caf-4de4-a424-cb03c5be2dbe",
  //         },
  //       },
  //       success: (result) => {
  //
  //         UtilObject.createCookie("ORDER_ID", result.ORDER_ID, 30);
  //         orderIdFromPHP = result.ORDER_ID;
  //       },
  //       error: (err) => {
  //
  //       },
  //     });
  //   }

  //

  //   var allCookies = UtilObject.getAllCookies();
  //

  //   $.ajax({
  //     url: globalThis.baseURL + "api/customer/Orders/getAllSessionValues",
  //     type: "GET",
  //     async: false,
  //     success: (result) => {
  //
  //       orderIdFromPHP = result.ORDER_ID;
  //     },
  //     error: (err) => {
  //
  //     },
  //   });

  //   CartDetails["ORDER_ID"] = UtilObject.getCookie("CUSTOMER_ID");
  //   CartDetails["CUSTOMER_ID"] = UtilObject.getCookie("ORDER_ID");

  //   this.cartCheck();
  // };

  // cartCheck = () => {
  //   $.ajax({
  //     url: globalThis.baseURL + "api/customer/Cart/CartDetails",
  //     type: "GET",
  //     async: false,
  //     success: (result) => {
  //
  //       if (result.code != 18) {
  //         this.showProductsInCart(result.Products);
  //       }
  //     },
  //     error: (err) => {
  //
  //     },
  //   });
  // };

  deleteEntireCart = () => {
    CartDetails = UtilObject.getAllCookies();

    $.ajax({
      url: globalThis.baseURL + "api/customer/Cart/DeleteCart",
      type: "POST",

      data: {
        Order_ID: CartDetails["ORDER_ID"],
      },
      headers: { Authorization: globalThis.X_API_KEY },
      success: (result) => {
        CartObject.notifyCartUpdate();
        this.ItemsAddedInCart.addClass("d-none");
        $("#checkOutBtn").addClass("d-none");
        this.cartEmpty.removeClass("d-none");
        this.refreshCart();
      },
      error: (err) => {},
    });
  };

  refreshCart = () => {
    var itemsInCart = $("div.cart-items").children();

    if (itemsInCart.length > 0) {
      for (let index = 0; index < itemsInCart.length; index++) {
        var item = itemsInCart[index];
        var itemId = $(item).attr("value");

        //Replacing Added with Add
        $(`.addedToCart[value='${itemId}']`).replaceWith(
          `<button type="button" class="btn btn-sm text-white w-100 addToCartBtn" style="background: #ff385c;" value="${itemId}">ADD</button>`,
        );
      }
      $(".addToCartBtn").off("click");
      $(".addToCartBtn").on("click", this.addItemInCart);
    }
    $(".cart-items").empty();
  };

  //this is to add/update cart in db
  addtoCart = async (product, type) => {
    await CartObject.cartCheck();

    UtilObject.getPhpCookies();

    $.ajax({
      url: globalThis.baseURL + "api/customer/Cart/AddtoCart",
      type: "POST",

      data: {
        Vendor_ID: vendor.vendor.Vendor_ID,
        Product_ID: product.Product_ID,
        Quantity: product.Quantity,
        Type: type,
      },
      headers: { Authorization: globalThis.X_API_KEY },
      success: (result) => {
        if (type == "ADD") {
          this.addItemToCartUI(product);
        }
        CartObject.notifyCartUpdate();
      },
      error: (err) => {
        var errorData = err.responseJSON;

        $(".addToCartErrorMessage").html(errorData.Msg);
        window.$("#addToCartError").modal("show");
        if (errorData.code == "12") {
          if (type == "ADD") {
            $(`.addToCartBtn[value="${product.Product_ID}"]`).replaceWith(
              `<button type="button" class="btn btn-sm btn-secondary text-white w-100" value="${product.Product_ID}">NOT AVAILABLE</button>`,
            );
          }
        }
        CartObject.notifyCartUpdate();
      },
    });
  };

  showProductsInCart = (products) => {
    this.cartEmpty.addClass("d-none");
    this.ItemsAddedInCart.removeClass("d-none");
    $("#checkOutBtn").removeClass("d-none");

    $(".vendorName").html(`${vendorFromOrder.Business_Name}`);

    $(".cart-items").empty();
    products.forEach((product) => {
      //   var cartItem = `<div class="row ${product.Product_ID}">
      //     <div class="col">
      //         ${product.ProductName}
      //     </div>
      //     <div class="col text-right itemPrice">
      //         <div class="d-flex flex-row">
      //             <button class="btn btn-link px-2 minusButton" onclick="this.parentNode.querySelector('input[type=number]').stepDown()">
      //                 <svg xmlns="http://www.w3.org/2000/svg" style="margin-left : 2rem;" width=30 height=30 fill="currentColor" class="bi bi-dash-square-fill" viewBox="0 0 16 16">
      //                     <path d="M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2zm2.5 7.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1 0-1z" />
      //                 </svg>
      //             </button>

      //             <!-- need to disable text field -->
      //             <input min="0" max="5" name="quantity" value="${product.Quantity}" type="number" class="form-control form-control-sm quantityButton qntyTextField" style="width: 45px; height:45px" disabled />

      //             <button class="btn btn-link px-2 plusButton" onclick="this.parentNode.querySelector('input[type=number]').stepUp()">
      //                 <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor" class="bi bi-plus-square-fill" viewBox="0 0 16 16">
      //                     <path d="M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2zm6.5 4.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3a.5.5 0 0 1 1 0z" />
      //                 </svg>
      //             </button>

      //         </div>
      //     </div>
      //     <div class="col">
      //         Rs ${product.Price}
      //     </div>
      //     <span class="text-danger maxErrorMsg"></span>

      // </div>`;

      var cartItem = `<div class="row align-items-center pb-1 ${product.Product_ID}" value="${product.Product_ID}">
      <div class="col-4 pt-1">
      ${product.ProductName}
      </div>
      <div class="col-4 p-0 d-flex justify-content-center itemPrice">
          <ul class="pagination m-0">
              <li class="page-item"><button class="page-link minusButton" value="${product.Product_ID}">-
                  </button>
              </li>

              <li class="page-item"><button min="0" max="${product.Product_Details.Quantity}" name="${product.Product_ID}" value="1" type="number" class="page-link quantityButton qntyTextField" disabled>${product.Quantity}</button>
              </li>

              <li class="page-item"> <button class="page-link plusButton" value="${product.Product_ID}">+

                  </button>
              </li>
          </ul>
      </div>
      <div class="col-4 pt-1 d-flex justify-content-center">
          ₹ ${product.Price}
      </div>
      <span class="text-danger maxErrorMsg" value="${product.Product_ID}"></span>
  </div>`;

      $(".cart-items").append(cartItem);

      //var button = `<button type="button" class="btn btn-sm text-white px-4 mt-2 w-100 ${product.Product_ID}" style="background: #ff385c; margin-left: 0rem;">ADDED</button>`;
      var button = `<button type="button" class="btn btn-sm text-white w-100 addedToCart" style="background: #ff385c;" value="${product.Product_ID}">ADDED</button>`;
      // //Vendor Availability Button check
      // if (checkIfVendorAvailable == false) {
      //   var button = `<button class="btn text-white px-5" id="${product.Product_ID}" style="background: rgba(192,192,192); margin-left:-5rem;" type="button">N/A</button>`;
      // } else {
      //   var button = `<button class="btn btn-xl text-white px-5 addToCartBtn ${product.Product_ID}" style="background: #ff385c;" type="button">Add</button>`;
      // }
      // //Vendor Availability Button check ends

      $(`.addToCartBtn[value="${product.Product_ID}"]`).replaceWith(button);
    });
    $(".plusButton").off("click");
    $(".plusButton").on("click", this.plusItemFunction);

    $(".minusButton").off("click");
    $(".minusButton").on("click", this.minusItemFunction);

    // var itemsInCartCount = $("div.cart-items").children().length;
    // $("span.cartCount").html(`${itemsInCartCount}`);

    //Updating Number of Items in the Cart
    CartObject.notifyCartUpdate();
  };

  //this is to show added item to UI
  addItemInCart = async (event) => {
    if (event != undefined) {
      pID = event.currentTarget.value;
    }

    // Ensure we have the absolute latest cart state before making any decisions
    // This prevents the race condition where the modal doesn't show up on first click
    this.noOfProductsInCart = await CartObject.cartCheck();
    vendorFromOrder = this.noOfProductsInCart.vendor;

    if (vendorFromOrder == null || this.noOfProductsInCart.Products.length === 0) {
      this.addItemtoCartAfterVendorCheck();
    } else {
      if (vendorFromOrder.Vendor_ID != this.Vendor_ID) {
        bootstrap.Modal.getOrCreateInstance("#showCartModal").show();
      } else {
        this.addItemtoCartAfterVendorCheck();
      }
    }
    CartObject.notifyCartUpdate();
  };

  //plusItemFunction
  plusItemFunction = (event) => {
    var productID = event.currentTarget.value;

    //

    var itemQuantityField = $(`.qntyTextField[name="${productID}"]`);

    var itemCount = parseInt(itemQuantityField[0].innerHTML);

    var maxItemQuantity = parseInt($(itemQuantityField[0]).attr("max"));

    var itemsInCartCount = $("div.cart-items").children().length;

    var p = {};

    // this.qntyTextField.val().disabled = true;
    p.Product_ID = productID;
    p.Quantity = itemCount + 1;
    p.Total_Items = this.noOfProductsInCart.Products.length;

    if (p.Total_Items == 0) {
      this.addtoCart(p, "ADD");
    } else {
      this.addtoCart(p, "UPDATE_QTY");
    }
  };

  //miuusItemFunction
  minusItemFunction = (event) => {
    var productID = event.currentTarget.value;

    //

    var itemQuantityField = $(`.qntyTextField[name="${productID}"]`);

    var itemCount = parseInt(itemQuantityField[0].innerHTML);

    var itemsInCartCount = $("div.cart-items").children().length;

    var p = {};

    //validation for - btn
    if (itemCount - 1 == 0) {
      //Removing Item from Cart

      $(`div.row.${productID}`).remove();

      //Replacing Added with Add
      $(`.addedToCart[value='${productID}']`).replaceWith(
        `<button type="button" class="btn btn-sm text-white w-100 addToCartBtn" style="background: #ff385c;" value="${productID}">ADD</button>`,
      );
      UtilObject.showToast("Item removed from cart!", "danger");
      $(".addToCartBtn").off("click");
      $(".addToCartBtn").on("click", this.addItemInCart);

      //If Cart is Empty
      itemsInCartCount = $("div.cart-items").children().length;

      if (itemsInCartCount == 0) {
        this.cartEmpty.removeClass("d-none");
        this.ItemsAddedInCart.addClass("d-none");
        $("#checkOutBtn").addClass("d-none");
        this.deleteEntireCart();
        //this.refreshCartCount();
      } else {
        p.Product_ID = productID;
        p.Quantity = itemCount - 1;
        p.Total_Items = itemsInCartCount;

        this.addtoCart(p, "UPDATE_QTY");
        //this.refreshCartCount();
      }
    } else {
      $(`.maxErrorMsg[value='${productID}']`).html("");
      p.Product_ID = productID;
      p.Quantity = itemCount - 1;
      p.Total_Items = itemsInCartCount;

      this.addtoCart(p, "UPDATE_QTY");
      //this.refreshCartCount();
      //$(itemQuantityField[0]).html(itemCount - 1);
    }

    CartObject.notifyCartUpdate();
  };

  //api

  // allow products/servicies to be added to the cart
  // getVendorDetails = () => {
  //
  //   $.ajax({
  //     url: globalThis.baseURL + "api/customer/ProductSummary/getVendorImages",
  //     type: "POST",
  //     data: {
  //       Vendor_ID: this.Vendor_ID,
  //     },
  //     success: this.showVendorDetails,
  //     error: this.showVendorDetails,
  //   });
  // };
  showVendorDetails = async (res) => {
    console.log("Locaso: Loading Vendor Details Optimized (v3.0)");
    this.hideProductListingSkeleton();
    screenWidth = $(window).width();

    $(".vendorName").html(`${res.vendor.Business_Name}`);

    vendorProducts = res.products;
    vendor = res;

    // 1. Group products by Picklist_ID for faster access
    const productsByCategory = {};
    if (Array.isArray(res.products)) {
      res.products.forEach((p) => {
        const catId = p.Picklist_ID;
        if (!productsByCategory[catId]) productsByCategory[catId] = [];
        productsByCategory[catId].push(p);
      });
    }

    // 2. Pre-calculate delivery UI
    if (res.delivery && res.delivery.length > 0) {
      const d = res.delivery[0];
      const deliveryPrice = d.Price > 0 ? "₹" + d.Price : "Free";
      const distanceKms = d.Distance_kms > 0 ? d.Distance_kms + " kms" : "";
      $(".deliveryOptionBtn").show();
      $(".vendorDeliveryOptions").html(
        `${d.Picklist_display_value} ${distanceKms} ${deliveryPrice}`,
      );
    } else {
      $(".deliveryOptionBtn").hide();
    }

    // 3. Availability UI
    const availability = res.vendor.Availability;
    if (res.vendor.Vendor_Availability === true) {
      const venEndTime = availability.End_time;
      const timeStr = new Date(
        "1970-01-01T" + venEndTime + "Z",
      ).toLocaleTimeString("en-US", {
        timeZone: "UTC",
        hour12: true,
        hour: "numeric",
        minute: "numeric",
      });
      $(".vendorAvailability").html(
        `<div class="hero-status-dot hero-status-open"></div><span class="text-success fw-bold">Open</span>`,
      );
      $(".vendorAvailabilityExtraMessage").html(`<span class="hero-dot-separator">•</span>Closes at ${timeStr}`);
    } else {
      const venStartTime = availability.Tomorrow?.Start_time || "08:00:00";
      const timeStr = new Date(
        "1970-01-01T" + venStartTime + "Z",
      ).toLocaleTimeString("en-US", {
        timeZone: "UTC",
        hour12: true,
        hour: "numeric",
        minute: "numeric",
      });
      $(".vendorAvailability").html(
        `<div class="hero-status-dot hero-status-closed"></div><span class="text-danger fw-bold">Closed</span>`,
      );
      $(".vendorAvailabilityExtraMessage").html(`<span class="hero-dot-separator">•</span>Opens at ${timeStr}`);
    }

    // 4. Vendor Info UI
    $(".vendorBusinessName").html(res.vendor.Business_Name);
    $(".vendorShortAddress").html(
      `${res.vendor.Address.City}, ${res.vendor.Address.State}`,
    );
    $(".vendorDescription").html(res.vendor.Specialities);
    $(".vendorMinOrder").html(res.vendor.Minimum_Order);

    // Rating / New Badge
    if (res.vendor.Vendor_Rating > 0) {
      const rating = res.vendor.Vendor_Rating;
      if (screenWidth < 576) {
        $(".vendorRatingMobile").html(
          `<span class="fw-bold" style="color: #484848;">${rating} <i class="fa-solid fa-star" style="color: #ffc107; font-size: 0.8rem;"></i></span>`,
        );
      } else {
        $(".vendorRating").html(`<span class="fw-bold" style="color: #484848;">${rating} <i class="fa-solid fa-star" style="color: #ffc107; font-size: 0.9rem;"></i></span>`);
      }
    } else {
      const badge = `<span class="badge bg-light text-brand border px-2 py-1" style="font-size: 0.7rem; margin-left: 0 !important;">NEW</span>`;
      $(".vendorRating, .vendorRatingMobile").html(badge);
    }

    const vendorImg = getVendorBusinessImageUrl(res.vendor.Image_URL, 1);
    $(".vendorMainImage").attr("src", vendorImg);

    // 5. Categories and Products Rendering (Optimized)
    const vendorCategories = res.categories || [];
    if (vendorCategories.length === 0) {
      $(".noCategoriesForVendor").removeClass("d-none");
    } else {
      if (vendorCategories.length === 1)
        $(".categories-product-listing").hide();
      $(".categoriesForVendorsExists").removeClass("d-none");

      const categoryItemsHTML = [];
      const allProductSectionsHTML = [];

      vendorCategories.forEach((category, i) => {
        const status = i === 0 ? "active" : "";
        const firstActiveItem = i === 0 ? "currentActiveCategory" : "";
        const selecteditem = i === 0 ? "selected-item" : "";

        // Build Category Tab
        categoryItemsHTML.push(`
          <div class="item">
            <div class="col-md-12 wow fadeInUp d-flex justify-content-center">
              <div id="${category.Picklist_ID}" class="vendorCategoriesButtons ${selecteditem} text-center zoom ${status} ${firstActiveItem}">
                <a class="btn-light rounded-circle" style="margin-top:0.5rem;">
                  <img src="${getImageUrl(category.Icon_Url) || globalThis.baseURL + "/assets/default.png"}" class="img-fluid rounded-circle" alt="${category.Picklist_display_value}-icon">
                </a>
                <p class="truncate">${category.Picklist_display_value}</p>
              </div>
            </div>
          </div>`);

        // Build Product Sections for this Category
        const catProducts = productsByCategory[category.Picklist_ID] || [];
        const recommendedItems = [];
        const menuItems = [];

        catProducts.forEach((product) => {
          const productHTML = buildProductCard(product, { 
            isCarousel: false,
            className: "col-6 col-lg-4" 
          });

          if (product.Recommended_flag) recommendedItems.push(productHTML);
          menuItems.push(productHTML);
        });

        const recSection = recommendedItems.length
          ? `<div class="${category.Picklist_ID}-recommended"><h4 class="p-2">Best Sellers</h4><div class="row g-2 g-sm-3">${recommendedItems.join("")}</div></div>`
          : "";
        const menuSection = menuItems.length
          ? `<div class="pb-1 ${category.Picklist_ID}-menu"><h4 class="p-2">Menu</h4><div class="row g-2 g-sm-3">${menuItems.join("")}</div></div>`
          : "";

        allProductSectionsHTML.push(`<span class="vendor-category-products ${category.Picklist_ID} ${i > 0 ? "d-none" : ""}">
            ${recSection} ${menuSection}
        </span>`);
      });

      // Batch DOM update categories
      const categoryCarousel = $(".owl-carousel.vendor-categories-item");
      categoryCarousel.trigger("destroy.owl.carousel").empty();
      categoryCarousel.append(categoryItemsHTML.join(""));
      this.calOwlCarousel(); // Re-initialize once

      // Batch DOM update products
      $(".all-vendor-category-products")
        .empty()
        .append(allProductSectionsHTML.join(""));
    }

    $(".vendorCategoriesButtons").on("click", this.showVendorCategoriesDetails);
    $(".addToCartBtn").off("click").on("click", this.addItemInCart);

    CartObject.notifyCartUpdate();
    if (this.noOfProductsInCart.Products.length > 0) {
      this.showProductsInCart(this.noOfProductsInCart.Products);
    }
  };

  vendorImageCarousel = (ImageUrl, vendorImages = []) => {
    $(".vendorImagesCarousel").empty();

    const screenWidth = $(window).width();
    if (screenWidth < 576) {
      $(".moreImagesMobile").removeClass("d-none");
    } else {
      $(".moreImagesDesktop").removeClass("d-none");
    }

    const imageList = [];
    const pushUnique = (value) => {
      if (!value) return;
      const normalized = String(value).trim();
      if (!normalized) return;
      if (!imageList.includes(normalized)) {
        imageList.push(normalized);
      }
    };

    // Primary image from vendor_master.Image_URL
    pushUnique(ImageUrl);

    // Additional images from vendor_images table
    if (Array.isArray(vendorImages)) {
      vendorImages
        .slice()
        .sort((a, b) => {
          const aNo = parseInt(
            String(a?.Image_URL || "").match(/BusinessImage(\d+)\.png$/)?.[1] ||
              "99",
            10,
          );
          const bNo = parseInt(
            String(b?.Image_URL || "").match(/BusinessImage(\d+)\.png$/)?.[1] ||
              "99",
            10,
          );
          return aNo - bNo;
        })
        .forEach((img) => pushUnique(img?.Image_URL));
    }

    // Legacy fallback: old folder-key style in Image_URL
    const normalizedPrimary = String(ImageUrl || "").replace(/^\/+/, "");
    const isLegacyFolderKey =
      normalizedPrimary &&
      !normalizedPrimary.startsWith("http") &&
      !normalizedPrimary.startsWith("uploads/") &&
      !normalizedPrimary.startsWith("Vendor/") &&
      !/\.(png|jpe?g|gif|webp)$/i.test(normalizedPrimary);

    if (isLegacyFolderKey && imageList.length === 1) {
      pushUnique(getVendorBusinessImageUrl(ImageUrl, 2));
      pushUnique(getVendorBusinessImageUrl(ImageUrl, 3));
    }

    imageList.forEach((imgPath, index) => {
      const active = index === 0 ? "active" : "";
      const imageUrl = getVendorBusinessImageUrl(imgPath, index + 1);

      $(".vendorImagesCarousel").append(`
      <div class="carousel-item ${active}" data-bs-interval="5000">
        <img src="${imageUrl}" 
             class="d-block w-100" 
             onerror="this.style.display='none'" 
             alt="Vendor Images">
      </div>
    `);
    });
  };

  showVendorCategoriesDetails = (event) => {
    // var prevCategoryID = $("input[type=radio]:checked").next().attr("id");
    // $("input[type=radio]:checked").prop("checked", false);
    // $(event.target).prev().prop("checked", true);
    // var newCategoryID = $(event.target).attr("id");

    var prevCategoryID = $(".currentActiveCategory").attr("id");
    var newCategoryID = $(event.currentTarget).attr("id");

    $(`span.${prevCategoryID}`).addClass("d-none");
    $(`span.${newCategoryID}`).removeClass("d-none");

    // //show and hide
    // $("span." + prevCategoryID).hide();
    // $("span." + newCategoryID).show();

    $(`div#${prevCategoryID}`).removeClass("currentActiveCategory");
    $(`div#${newCategoryID}`).addClass("currentActiveCategory");
    //Remove active class
    $(`div#${prevCategoryID}`).removeClass("active");
    $(`div#${newCategoryID}`).addClass("active");

    //show selected items
    $(`div#${prevCategoryID}`).removeClass("selected-item");
    $(`div#${newCategoryID}`).addClass("selected-item");
  };

  getVendorDetailsWithMultipleCategories = () => {
    $.ajax({
      url:
        globalThis.baseURL +
        "api/customer/ProductSummary/getVendorDetailsWithMultipleCategories",
      type: "POST",

      data: {
        Vendor_ID: this.Vendor_ID,
      },
      headers: { Authorization: globalThis.X_API_KEY },
      success: (result) => {
        this.showVendorDetails(result);
      },
      error: (result) => {
        this.hideProductListingSkeleton();
        $(".emptyProductListingPage").removeClass("d-none");
      },
    });
  };

  addItemtoCartAfterVendorCheck = () => {
    if (flagForVendorCheck) {
    } else {
    }

    //
    //var pID = event.currentTarget.getAttribute("id");

    var itemsInCartCount = $("div.cart-items").children().length;

    vendorProducts.forEach((p) => {
      if (p.Product_ID == pID) {
        // Add to cart first and if added then show item in cart otherwise show error modal
        var productDetailsToSend = p;
        productDetailsToSend.Quantity = 1;
        itemsInCartCount = $("div.cart-items").children().length;
        productDetailsToSend.Total_Items = itemsInCartCount;

        this.addtoCart(productDetailsToSend, "ADD");
        UtilObject.showToast("Item added to cart!", "success");

        //   var cartItem = `<div class="row ${p.Product_ID}">
        //   <div class="col">
        //       ${p.Product_Service_Name}
        //   </div>
        //   <div class="col text-right itemPrice">
        //       <div class="d-flex flex-row">
        //           <button class="btn btn-link px-2 minusButton" onclick="this.parentNode.querySelector('input[type=number]').stepDown()">
        //               <svg xmlns="http://www.w3.org/2000/svg" style="margin-left : 2rem;" width=30 height=30 fill="currentColor" class="bi bi-dash-square-fill" viewBox="0 0 16 16">
        //                   <path d="M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2zm2.5 7.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1 0-1z" />
        //               </svg>
        //           </button>

        //           <!-- need to disable text field -->
        //           <input min="0" max="5" name="quantity" value="1" type="number" class="form-control form-control-sm quantityButton qntyTextField" style="width: 45px; height:45px" disabled />

        //           <button class="btn btn-link px-2 plusButton" onclick="this.parentNode.querySelector('input[type=number]').stepUp()">
        //               <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor" class="bi bi-plus-square-fill" viewBox="0 0 16 16">
        //                   <path d="M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2zm6.5 4.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3a.5.5 0 0 1 1 0z" />
        //               </svg>
        //           </button>

        //       </div>
        //   </div>
        //   <div class="col">
        //       Rs ${p.Price}
        //   </div>
        //   <span class="text-danger maxErrorMsg"></span>

        // </div>`;

        // $.ajax({
        //   url: globalThis.baseURL + "api/customer/Orders/AddtoCart",
        //   type: "POST",
        //   async: false,
        //   data: {
        //     data: {
        //       Order_ID:CartDetails.ORDER_ID,
        //       Vendor_ID:p.Vendor_ID,
        //       Customer_ID:CartDetails.CUSTOMER_ID,
        //       Product_ID:p.Product_ID,
        //       Quantity:1,
        //       Packaging_charge:,
        //       Flow:
        //     }
        //   }
        //   success: (result) => {
        //
        //   },
        //   error: (err) => {
        //
        //   },
        // });
      }
    });
  };

  addItemToCartUI = async (product) => {
    //add cart and remove empty cart ui
    this.cartEmpty.addClass("d-none");
    this.ItemsAddedInCart.removeClass("d-none");
    $("#checkOutBtn").removeClass("d-none");

    var cartItem = `<div class="row align-items-center pb-1 ${product.Product_ID}" value="${product.Product_ID}">
      <div class="col-4 pt-1">
      ${product.Product_Service_Name}
      </div>
      <div class="col-4 p-0 d-flex justify-content-center itemPrice">
          <ul class="pagination m-0">
              <li class="page-item"><button class="page-link minusButton" value="${product.Product_ID}">-
                  </button>
              </li>

              <li class="page-item"><button min="0" max="${(product.Product_Details && product.Product_Details.Quantity) || product.Quantity || 0}" name="${product.Product_ID}" value="1" type="number" class="page-link quantityButton qntyTextField" disabled>1</button>
              </li>

              <li class="page-item"> <button class="page-link plusButton" value="${product.Product_ID}">+

                  </button>
              </li>
          </ul>
      </div>
      <div class="col-4 pt-1 d-flex justify-content-center">
          ₹ ${product.Price}
      </div>
      <span class="text-danger maxErrorMsg" value="${product.Product_ID}"></span>
  </div>`;

    $(".cart-items").append(cartItem);

    //Click events for plus and minus buttons
    $(".plusButton").off("click");
    $(".plusButton").on("click", this.plusItemFunction);

    $(".minusButton").off("click");
    $(".minusButton").on("click", this.minusItemFunction);

    //if text field =!0 then add->replace addressDetails

    var quantityValue = $(`.${product.Product_ID} .qntyTextField`).attr(
      "value",
    );
    if (quantityValue != 0) {
      // $(`button.${pID}`).replaceWith(
      //   `<button type="button" class="btn btn-sm text-white px-4 mt-2 w-100 ${pID}" style="background: #ff385c; margin-left: 0rem;">ADDED</button>`
      // );
      $(`.addToCartBtn[value="${product.Product_ID}"]`).replaceWith(
        `<button type="button" class="btn btn-sm text-white w-100 addedToCart" style="background: #ff385c;" value="${product.Product_ID}">ADDED</button>`,
      );
    }

    this.noOfProductsInCart = await CartObject.cartCheck();
    vendorFromOrder = this.noOfProductsInCart.vendor;

    this.refreshCartCount();
  };

  loadProductImages = (res) => {
    res.forEach((item) => {
      const className = item.Product_ID + "forImg";
      const imageUrl = getImageUrl(item.Image_URL);

      const nodes = document.getElementsByClassName(className);

      [...nodes].forEach((el) => {
        el.src = imageUrl;
      });
    });
  };

  loadCategoryImages = (res) => {
    //For each Category the VENDOR has

    res.forEach(async (elements) => {
      var customSpecID = elements.Picklist_ID + "forImg";

      const imageUrl = getImageUrl(elements.Icon_Url);

      document.getElementById(customSpecID).src =
        imageUrl || globalThis.baseURL + "/assets/default.png";
    });
  };
}